module.exports = __webpack_public_path__ + "static/media/id.b69465c1.png";